import {
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  Output,
} from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { FUNCAO_REGRA_COMPOSTA, Regra } from "../../regra";
import { RegraService } from "../../regra.service";
import { ToastService } from "maps-angular-components";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: "modal-deletar-regra",
  templateUrl: "modal-deletar-regra.component.html",
})
export class ModalDeletarRegraDialogComponent implements OnDestroy {
  private readonly subscriptions = new Subscription();

  service: RegraService;
  _message;

  @Output() deletado = new EventEmitter();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Regra,
    service: RegraService,
    private readonly messageService: ToastService
  ) {
    this.service = service;
    this._message = messageService;
  }

  excluir() {
    this.service.excluirRegra(this.data.id, (this.data.funcao === FUNCAO_REGRA_COMPOSTA)).subscribe(
      () => {
        this.messageService.textoLight("Regra deletada com sucesso.");
        this.deletado.emit();
      },
        (err: HttpErrorResponse)=> this.messageService.erro(err.error.message)
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
